import { IUserOrganization } from "../../../models/Multitenancy/IUserOrganization";
import { queryResponse, sibaAuthApi } from "../../backends/sibaApis";

const api = "api/UserOrganization";
/***
 * Service definition for Organization setup
 *  */
const UserOrganizationApi = sibaAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Get all endpoint
         *
         */
        queryAllUserOrganization: builder.query<IUserOrganization[], void>({
            query: () => ({ url: `${api}`, method: "GET" })
        }),
        /**
         * Get by id endpoint
         * query expects object with parameters id.
         * id destructured and passed as a query parameter.
         */
        queryUserOrganization: builder.query<queryResponse<IUserOrganization>, string>({
            query: (id: string) => ({ url: `${api}/${id}`, method: "GET" })
        }),

        /**
         * Save  endpoint
         *
         */
        saveUserOrganization: builder.mutation<queryResponse<any>, IUserOrganization[]>({
            query: (obj: IUserOrganization[]) => ({
                url: `${api}`,
                method: "POST",
                //body: obj,
                data: obj
            })
        }),

        /**
         * Update  endpoint
         * query expects object of type country model.
         * id field is destructure and passed as a query parameter.
         */
        updateUserOrganization: builder.mutation<queryResponse<number>, IUserOrganization>({
            query: ({ id, ...rest }: any) => ({
                url: `${api}/${id}`,
                method: "PUT",
                // body: { ${}id, ...rest },
                data: { id, ...rest }
            })
        }),
        /**
         * Remove  endpoint
         * query expects object with parameters id and modified by (string).
         * id and modifiedby propertied destructured and passed as a query parameter.
         */
        removeUserOrganization: builder.mutation<queryResponse<number>, IUserOrganization>({
            query: ({ id, modifiedBy }: any) => ({
                url: `${api}/${id}/${modifiedBy}`,
                method: "DELETE"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getAllUserOrganization: builder.mutation<IUserOrganization[], void>({
            query: () => ({
                url: `${api}`,
                method: "GET"
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchUserOrganization: builder.mutation<queryResponse<IUserOrganization[]>, any>({
            query: (query: any) => ({
                url: `${api}/search`,
                method: "POST",
                // body: query,
                data: query
            })
        }),

        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getUserOrganization: builder.mutation<IUserOrganization[], void>({
            query: () => ({
                url: `${api}/lov`,
                method: "GET"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getUserOrganizationLovCode: builder.mutation<IUserOrganization[], void>({
            query: () => ({
                url: `${api}/lov?code=true`,
                method: "GET"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getUserOrganizationLovString: builder.mutation<IUserOrganization[], void>({
            query: () => ({
                url: `${api}/lov?code=false`,
                method: "GET"
            })
        }),
        /**
         * Get all User Organizations by User Id mutation query.
         */
        getUserOrganizationByUserId: builder.mutation<IUserOrganization[], string | undefined>({
            query: (id: string | undefined) => ({ url: `${api}/by/user/${id}`, method: "GET" })
        })
    })
});

export const {
    useSaveUserOrganizationMutation,
    useUpdateUserOrganizationMutation,
    useRemoveUserOrganizationMutation,
    useSearchUserOrganizationMutation,
    useGetUserOrganizationLovCodeMutation,
    useGetUserOrganizationLovStringMutation,
    useGetAllUserOrganizationMutation, 
    useGetUserOrganizationByUserIdMutation
} = UserOrganizationApi;
